/**
 * DIEUKYDIEU.TV - CATEGORY DETAIL ARTICLES GRID & PAGINATION
 */
import { createCardElement, renderEmptyStateHTML } from '../components/index.js';
import {
    currentCategoryArticles,
    filteredCategoryArticles,
    selectedTier1,
    selectedTier2,
    categoryCurrentPage,
    categoryPageSize,
    setCategoryCurrentPage
} from './explore-detail.js';

let categoryScrollObserver = null;
let isCategoryInfiniteLoading = false;

export function updateFilterStatusBar() {
    const pathTextEl = document.getElementById('cat-filter-path-text');
    const countBadgeEl = document.getElementById('cat-filtered-count-badge');

    let pathDesc = 'Tất cả bài viết';
    if (selectedTier1 && selectedTier1 !== 'all') {
        pathDesc = selectedTier1.name;
        if (selectedTier2 && selectedTier2 !== 'all') {
            pathDesc += ` › ${selectedTier2.name}`;
        }
    }

    if (pathTextEl) pathTextEl.textContent = pathDesc;
    if (countBadgeEl) {
        countBadgeEl.textContent = `${filteredCategoryArticles.length} bài viết`;
    }
}

export function renderCategoryArticlesGrid(reset = true) {
    const listEl = document.getElementById('cat-detail-list');
    if (!listEl) return;

    if (reset) {
        listEl.innerHTML = '';
    }

    if (!filteredCategoryArticles || filteredCategoryArticles.length === 0) {
        listEl.innerHTML = renderEmptyStateHTML({
            icon: 'article',
            title: 'Chưa có bài viết cho mục này',
            desc: 'Vui lòng chọn danh mục khác hoặc đặt lại bộ lọc để khám phá các bài viết bổ ích.',
            actionText: 'Xem tất cả bài viết',
            actionOnClickAttr: "onSelectTier1('all', document.querySelector('#cat-tier1-chips .cat-chip'))"
        });
        updatePaginationAndInfiniteScroll();
        return;
    }

    const startIdx = reset ? 0 : (categoryCurrentPage - 1) * categoryPageSize;
    const endIdx = categoryCurrentPage * categoryPageSize;
    const articlesToShow = filteredCategoryArticles.slice(startIdx, endIdx);

    articlesToShow.forEach((art, idx) => {
        const isLead = (startIdx === 0 && idx === 0);
        const cardEl = createCardElement({
            id: art.id,
            title: art.title,
            desc: art.desc,
            img: art.img,
            duration: '',
            variant: 'editorial',
            legacyClass: isLead ? 'article-card cat-lead-card' : 'article-card',
            staggerIndex: idx % categoryPageSize,
            onClick: () => {
                if (typeof window.openStoryDetail === 'function') {
                    window.openStoryDetail(art);
                }
            }
        });
        cardEl.style.animationDelay = `${(idx % categoryPageSize) * 0.05}s`;
        listEl.appendChild(cardEl);
    });

    updatePaginationAndInfiniteScroll();
}

export function updatePaginationAndInfiniteScroll() {
    const totalArticles = filteredCategoryArticles.length;
    const currentlyShowing = Math.min(categoryCurrentPage * categoryPageSize, totalArticles);

    const loadMoreWrapper = document.getElementById('cat-load-more-wrapper');
    const loadingIndicator = document.getElementById('cat-loading-indicator');
    const endNotice = document.getElementById('cat-end-notice');
    const paginationBar = document.getElementById('cat-pagination-bar');

    // Ẩn hoàn toàn cụm số phân trang cũ theo chuẩn Apple Modern Flow
    if (paginationBar) {
        paginationBar.innerHTML = '';
        paginationBar.style.display = 'none';
    }

    if (totalArticles === 0) {
        if (loadMoreWrapper) loadMoreWrapper.style.display = 'none';
        if (loadingIndicator) loadingIndicator.style.display = 'none';
        if (endNotice) endNotice.style.display = 'none';
        return;
    }

    if (currentlyShowing < totalArticles) {
        if (loadMoreWrapper) {
            loadMoreWrapper.style.display = 'flex';
            loadMoreWrapper.innerHTML = `
                <div class="cat-progress-counter">Đang hiển thị <strong>${currentlyShowing}</strong> / ${totalArticles} bài viết</div>
                <button class="cat-load-more-btn" id="cat-load-more-btn" type="button" onclick="loadMoreCategoryArticles()" aria-label="Tải thêm bài viết">
                    <span>Tải thêm bài viết</span>
                    <span class="material-symbols-rounded">expand_more</span>
                </button>
            `;
        }
        if (endNotice) endNotice.style.display = 'none';
    } else {
        if (loadMoreWrapper) loadMoreWrapper.style.display = 'none';
        if (endNotice) {
            endNotice.style.display = 'flex';
            endNotice.innerHTML = `
                <span class="material-symbols-rounded">check_circle</span>
                <span>Đã hiển thị tất cả ${totalArticles} bài viết</span>
            `;
        }
    }
}

export function loadMoreCategoryArticles() {
    const totalArticles = filteredCategoryArticles.length;
    if (categoryCurrentPage * categoryPageSize >= totalArticles) return;

    const btn = document.getElementById('cat-load-more-btn');
    if (btn) {
        btn.innerHTML = `
            <span class="apple-spinner"></span>
            <span>Đang tải...</span>
        `;
        btn.style.pointerEvents = 'none';
    }

    setTimeout(() => {
        setCategoryCurrentPage(categoryCurrentPage + 1);
        renderCategoryArticlesGrid(false);
    }, 240);
}


export function goToCategoryPage(page) {
    const totalArticles = filteredCategoryArticles.length;
    const totalPages = Math.ceil(totalArticles / categoryPageSize) || 1;
    if (page < 1 || page > totalPages) return;

    setCategoryCurrentPage(page);
    renderCategoryArticlesGrid(true);

    const stickyBar = document.getElementById('cat-filter-sticky-bar');
    if (stickyBar) {
        stickyBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
}

export function setupCategoryInfiniteScroll() {
    if (categoryScrollObserver) {
        categoryScrollObserver.disconnect();
    }

    const sentinel = document.getElementById('cat-detail-scroll-sentinel');
    if (!sentinel || typeof IntersectionObserver === 'undefined') return;

    categoryScrollObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !isCategoryInfiniteLoading) {
                const totalArticles = filteredCategoryArticles.length;
                if (categoryCurrentPage * categoryPageSize < totalArticles) {
                    isCategoryInfiniteLoading = true;
                    const loadingIndicator = document.getElementById('cat-loading-indicator');
                    if (loadingIndicator) loadingIndicator.style.display = 'flex';

                    setTimeout(() => {
                        loadMoreCategoryArticles();
                        if (loadingIndicator) loadingIndicator.style.display = 'none';
                        isCategoryInfiniteLoading = false;
                    }, 350);
                }
            }
        });
    }, { rootMargin: '250px' });

    categoryScrollObserver.observe(sentinel);
}

